import { render, staticRenderFns } from "./PurchasesFilters.vue?vue&type=template&id=c9309b68&"
import script from "./PurchasesFilters.vue?vue&type=script&lang=js&"
export * from "./PurchasesFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports